import { queryTestRuns } from '@/features/executions/data/testRuns';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult, TestRunDto } from '@flowqa/shared';

export const fetchTestRunsGrid = async (
  projectId?: string | null,
  organisationId?: string | null,
  input?: GridQueryInput,
): Promise<QueryResult<TestRunDto>> => {
  return await queryTestRuns(projectId ?? undefined, organisationId ?? undefined, input);
};
